import * as React from 'react';

import { COLORS } from '../../utility/tasks/colors';
import { AiOutlineFile, AiOutlineFileImage, AiOutlineFileText, AiOutlineFileZip } from 'react-icons/ai';
import { BsFileEarmarkWord, BsFileEarmarkPdf, BsFiletypeJson, BsFiletypeXml } from 'react-icons/bs';
import { LuFileVideo } from 'react-icons/lu';
import { MdOutlineMailOutline, MdOutlineAudioFile } from 'react-icons/md';
import { PiFileXlsBold } from 'react-icons/pi';
import { CmicContext } from '../../context/CmicContext';
import { fetchFileType } from '../../utility/UtilityFunctions';
import { FILE_TYPE } from '../../shared/Constants';
const FileTypeIcon = ({ name = '', color = COLORS.YELLOW, size = 20, iconStyles = {} }) => {
	const { currentOfficeTheme } = React.useContext(CmicContext);

	const extension = fetchFileType(name);

	const dimensions = {
		height: '23px',
		width: '29px',
		minHeight: '20px',
		minWidth: '20px',
	};

	if (extension === FILE_TYPE.Image) {
		return <AiOutlineFileImage style={{ color: COLORS.OUTLOOK_BLUE, ...dimensions }} />;
	} else if (extension === FILE_TYPE.Video) {
		return <LuFileVideo style={{ color, fontSize: size, ...iconStyles, ...dimensions, marginTop: '0px' }} />;
	} else if (extension === FILE_TYPE.Pdf) {
		return <BsFileEarmarkPdf style={{ color: 'red', ...dimensions }} />;
	} else if (extension === FILE_TYPE.Text) {
		return <AiOutlineFileText style={{ color: currentOfficeTheme.bodyForegroundColor, ...dimensions }} />;
	} else if (extension === FILE_TYPE.Email) {
		return <MdOutlineMailOutline style={{ color: currentOfficeTheme.bodyForegroundColor, ...dimensions }} />;
	} else if (extension === FILE_TYPE.JSON) {
		return <BsFiletypeJson style={{ color: currentOfficeTheme.bodyForegroundColor, ...dimensions }} />;
	} else if (extension === FILE_TYPE.Zip) {
		return <AiOutlineFileZip style={{ color: currentOfficeTheme.bodyForegroundColor, ...dimensions }} />;
	} else if (extension === FILE_TYPE.Excel) {
		return <PiFileXlsBold style={{ color: COLORS.GREEN, ...dimensions }} />;
	} else if (extension === FILE_TYPE.Audio) {
		return <MdOutlineAudioFile style={{ color: COLORS.PURPLE, ...dimensions }} />;
	} else if (extension === FILE_TYPE.Word) {
		return <BsFileEarmarkWord style={{ color: COLORS.ICON_BLUE_COLOR, ...dimensions }} />;
	} else if (extension === FILE_TYPE.Xml) {
		return <BsFiletypeXml style={{ color: COLORS.GREEN, ...dimensions }} />;
	} else {
		return <AiOutlineFile style={{ color: COLORS.YELLOW, ...dimensions }} />;
	}
};

export default FileTypeIcon;
